import { Country } from './country';
import { Entity } from './entity';

export class ResidencyJurisdiction {
  residencyJurisdictionId!: number;
  countryId!: number;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
  country!: Country;
  entities!: Entity[];
  name?: string;
  region?: string;
}
